import { render, staticRenderFns } from "./NewProperty.vue?vue&type=template&id=715f7e5f"
import script from "./NewProperty.vue?vue&type=script&lang=js"
export * from "./NewProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports